import React, { useState, useEffect } from 'react';
import GenericSpinnerLoader from '../../loaders/GenericSpinnerLoader';
import Icons from '../../assets/icons';
import LanguageTranslator from '../../locals/LanguageTranslator';


const SwitcherLoader = (props) => {

    const {moduleName='', isLoading} = props;

    const [loading, setLoading] = useState(0)

    useEffect(() => {
        if (moduleName) {

            let timers = [];

            if (isLoading) {
                // timers.push(setTimeout(() => setLoading(0), 100));
            } else {
                timers.push(setTimeout(() => setLoading(20), 200));
                timers.push(setTimeout(() => setLoading(40), 250));
                timers.push(setTimeout(() => setLoading(60), 300));
                timers.push(setTimeout(() => setLoading(80), 350));
                timers.push(setTimeout(() => setLoading(100), 400));
                // setLoading(100)
            }

            // Cleanup
            return () => {
                timers.forEach(clearTimeout);
            };

        }

    }, [isLoading])
    
    
    const getDetails = () => {
        let icons = {
            // "DIGIARS" : "https://assets-supplymint-com.s3.ap-south-1.amazonaws.com/Allokator-withoutSupplymint.svg",
            // "DIGIPROC" :  "https://assets-supplymint-com.s3.ap-south-1.amazonaws.com/Allokator-withoutSupplymint.svg",
            // "DIGISALES" :  "https://assets-supplymint-com.s3.ap-south-1.amazonaws.com/Allokator-withoutSupplymint.svg",
            // "DIGIVEND" : "https://assets-supplymint-com.s3.ap-south-1.amazonaws.com/Allokator-withoutSupplymint.svg",
            "DIGIARS" : <Icons.AllokatorWithLabel/>,
            "DIGIPROC" : <Icons.DigiProcWithLabel/>,
            "DIGISALES" : <Icons.DigiSalesWithLabel/>,
            "DIGIVEND" : <Icons.DigiVendWithLabel/>,
            "CDIGISALES" : <Icons.DigiSalesWithLabel/>,
        }

        let label = {
            "DIGIARS" : <><LanguageTranslator tag='span' className='font-semibold'>Allocate Smarter and cut down waste,</LanguageTranslator> <LanguageTranslator>Stay in control of your operations effortlessly.</LanguageTranslator></>,
            "DIGIPROC" :  <><LanguageTranslator tag='span' className='font-semibold'>Simplify Your Purchase Cycle,</LanguageTranslator> <LanguageTranslator>Centralized Tracking and Maximum Efficiency</LanguageTranslator></>,
            "DIGISALES" : <><LanguageTranslator tag='span' className='font-semibold'>Simplify B2B Sales Order Management,</LanguageTranslator> <LanguageTranslator>Built for Speed & Accuracy</LanguageTranslator></>,
            "DIGIVEND" : <><LanguageTranslator tag='span' className='font-semibold'>From dashboard to store aisle,</LanguageTranslator> <LanguageTranslator>your inventory stays in sight at every step</LanguageTranslator></>,
            "CDIGISALES" : <><LanguageTranslator tag='span' className='font-semibold'>Simplify B2B Sales Order Management,</LanguageTranslator> <LanguageTranslator>Built for Speed & Accuracy</LanguageTranslator></>,
        }

        return {
            icon : icons?.[moduleName],
            label : label?.[moduleName],
        }
    }

    if (!moduleName || moduleName === 'MDM' || moduleName === 'ADMIN') {
        return <div className='w-full h-screen bg-white flex items-center justify-center'>
            <div className='space-y-2 text-center'>
                <Icons.InfiniteLoop className='h-[30px] w-auto mx-auto mb-5' />
                <p className='text-fontBlack text-[19px] font-semibold mb-0'><LanguageTranslator>Loading Your Experience</LanguageTranslator>...</p>
                <p className='text-fontGrey text-[13px]'>“ <LanguageTranslator>We're getting things ready for you!</LanguageTranslator> ”</p>
            </div>
        </div>
    }

    let {icon, label} = getDetails?.();

    return (
        <div className='w-full h-screen bg-white flex items-center justify-center'>
            <div className='flex flex-col justify-center items-center'>
                {/* <img src={icon} width={'auto'} height={'50px'}/> */}
                <div className='mb-[60px] relative'>
                    <div style={{ opacity: 0.5 + (loading / 100) * 0.5 }}>{icon}</div>
                    <div 
                        style={{
                            width: `${100 - loading}%`
                        }} 
                        className='absolute top-[0] right-[0] z-[1] h-full duration-500 opacity-90 bg-white'
                    >
                    </div>
                </div>
                <p className='mb-[40px] text-base text-[#111D31]'>{label}</p>
                <p className='text-lg text-[#464646]'>{loading}%</p>

          </div>
        </div>
    )
}

export default SwitcherLoader;